export const TRIGGER_CLICK_KEY_CODES = ['Enter', 'Space'];
